var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.484701 4.23467C0.51954 4.19971 0.560937 4.17198 0.606519 4.15305C0.652101 4.13412 0.700971 4.12438 0.750326 4.12438C0.799681 4.12438 0.848551 4.13412 0.894133 4.15305C0.939714 4.17198 0.981112 4.19971 1.01595 4.23467L2.62501 5.84374L2.62501 1.24999C2.62501 1.15053 2.66452 1.05515 2.73485 0.984823C2.80517 0.914496 2.90056 0.874988 3.00001 0.874988C3.09947 0.874988 3.19485 0.914496 3.26518 0.984823C3.3355 1.05515 3.37501 1.15053 3.37501 1.24999L3.37501 5.84374L4.9847 4.23467C5.05515 4.16423 5.1507 4.12465 5.25033 4.12465C5.34995 4.12465 5.4455 4.16423 5.51595 4.23467C5.5864 4.30512 5.62598 4.40067 5.62598 4.5003C5.62598 4.59993 5.5864 4.69548 5.51595 4.76592L3.26595 7.01592C3.23111 7.05088 3.18971 7.07862 3.14413 7.09755C3.09855 7.11648 3.04968 7.12622 3.00033 7.12622C2.95097 7.12622 2.9021 7.11648 2.85652 7.09755C2.81094 7.07862 2.76954 7.05088 2.7347 7.01592L0.484701 4.76592C0.449741 4.73109 0.422002 4.68969 0.403075 4.64411C0.384148 4.59853 0.374405 4.54966 0.374405 4.5003C0.374405 4.45094 0.384148 4.40207 0.403075 4.35649C0.422002 4.31091 0.449741 4.26951 0.484701 4.23467Z",
    fill: "#099857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.ec5713dc4b2d592c424b0e3e2b5d5ce1.svg";
export { ForwardRef as ReactComponent };